export default function XML_HttpRequest() {
  return (
    <div>
      <h1>XML_HttpRequest</h1>
      <p>This is the XML_HttpRequest component.</p>
    </div>
  );
}